import { queryService } from '../../helpers/services/productQuery.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_QUERY_MODULE = 'productQuey'; 

// define action 
export const GET_ALL_PRODUCT_QUERIES = 'getAllProductQueries';
export const GET_PRODUCT_QUERY = 'getProductQuery';
export const UPDATE_PRODUCT_QUERY = 'updateProductQuery';
export const CREATE_PRODUCT_QUERY = 'createProductQuery';
export const UPDATE_PRODUCT_QUERY_STATUS = 'updateProductQueryStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_QUERIES_REQUEST = "getAllProductQueries";
const GET_PRODUCT_QUERY_REQUEST = "getProductQuery";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_QUERIES]({ commit }, { filter }) {
        await queryService
            .getAllQueries(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_QUERIES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_QUERY]({ commit }, { id }) {
        queryService
            .getQuery(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_QUERY_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_QUERY]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        queryService
            .updateQuery(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.query')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_QUERY]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        queryService
            .createQuery(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.query')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_QUERY_STATUS]({ dispatch }, { filter, data }) {
        queryService
            .updateQueryStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_QUERIES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if(isCloseWhenSuccess == false) {
            router.push({ name: "Product-query-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_QUERIES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                remark: o.remark,
                type: o.type,
                date: filtersHelper.getDateFormat(o.date),
                product: o.product,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_QUERY_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            remark: o.remark,
            date: o.date,
            product: o.product,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
            type: o.type == true ? 
            {
                value: o.type,
                text: "Query"
            } :
            {
                value: o.type,
                text: "Reply"
            }
        }

    }
}


